module.exports = __webpack_public_path__ + "static/media/bigbag.bf044239.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bigbag.jpg
// module id = 97
// module chunks = 0